import { defineMessages } from 'react-intl';

/** The copy of step 2 "Who Plug contacts" (design outreach-v2 c1, c2). */
export const whoMessages = defineMessages({
  aDay: { id: 'app.outreach.who.aDay', defaultMessage: 'a day' },
  aDayPerArtist: { id: 'app.outreach.who.aDayPerArtist', defaultMessage: 'a day per artist' },
  aDayAutopilot: { id: 'app.outreach.who.aDayAutopilot', defaultMessage: 'a day per artist · autopilot' },

  rateTitle: {
    id: 'app.outreach.who.rate.title',
    defaultMessage: 'Plug pitches {rate, plural, one {# new person} other {# new people}} a day for {song}',
  },
  rateBody: {
    id: 'app.outreach.who.rate.body',
    defaultMessage:
      'Every night Plug looks for new curators that fit your sound. Every morning it pitches the best {rate} from your mailbox.',
  },
  rateBodyUntil: {
    id: 'app.outreach.who.rate.bodyUntil',
    defaultMessage:
      'Every night Plug looks for new curators that fit your sound. Every morning it pitches the best {rate} from your mailbox. Up to {total} people before the campaign ends on {date}.',
  },
  rateFreeTitle: {
    id: 'app.outreach.who.rate.freeTitle',
    defaultMessage: 'Plug found {count, plural, one {# person} other {# people}} who fit {song}',
  },
  rateFreeBody: {
    id: 'app.outreach.who.rate.freeBody',
    defaultMessage:
      'On a paid plan Plug pitches them for you, every day, from your mailbox. Start with {pro} a day on Pro, or {label} a day on Ultra.',
  },
  rateFreeNote: {
    id: 'app.outreach.who.rate.freeNote',
    defaultMessage:
      'The kinds and the never-contact list still work, so the setup is ready when the plan starts. Start (step 5) opens the plans.',
  },
  rateTrialTitle: {
    id: 'app.outreach.who.rate.trialTitle',
    defaultMessage: 'Your trial pitches {rate, plural, one {# new person} other {# new people}} a day',
  },
  rateTrialBody: {
    id: 'app.outreach.who.rate.trialBody',
    defaultMessage:
      'Real pitches to real curators, so you see the replies come in. After the trial: {artist} a day on Plus, {pro} on Pro, {label} on Ultra.',
  },
  rateLabelBody: {
    id: 'app.outreach.who.rate.labelBody',
    defaultMessage:
      "Each artist of your label has their own {rate} a day. Autopilot sends the pitches that pass Plug's check, with no approval.",
  },
  rateManagerBody: {
    id: 'app.outreach.who.rate.managerBody',
    defaultMessage: 'Each of your artists has their own {rate} a day. Two songs of one artist share the {rate}.',
  },
  seePlans: { id: 'app.outreach.who.rate.seePlans', defaultMessage: 'See plans' },
  pitchOnLabel: { id: 'app.outreach.who.rate.pitchOnLabel', defaultMessage: 'Pitch {label} a day on Ultra' },
  askOwner: { id: 'app.outreach.who.rate.askOwner', defaultMessage: 'Ask the workspace owner' },
  yourPlan: { id: 'app.outreach.who.rate.yourPlan', defaultMessage: 'Your plan: {plan}' },
  trialEnds: { id: 'app.outreach.who.rate.trialEnds', defaultMessage: 'Trial ends {date}' },
  planArtist: { id: 'app.outreach.who.plan.artist', defaultMessage: 'Plus' },
  planPro: { id: 'app.outreach.who.plan.pro', defaultMessage: 'Pro' },
  planManager: { id: 'app.outreach.who.plan.manager', defaultMessage: 'Max' },
  planLabel: { id: 'app.outreach.who.plan.label', defaultMessage: 'Ultra' },
  planTrial: { id: 'app.outreach.who.plan.trial', defaultMessage: 'Trial' },
  planFree: { id: 'app.outreach.who.plan.free', defaultMessage: 'Free' },
  ladderYou: { id: 'app.outreach.who.ladder.you', defaultMessage: '{plan} · you' },

  kindsTitle: { id: 'app.outreach.who.kinds.title', defaultMessage: 'Who Plug looks for' },
  kindsHint: {
    id: 'app.outreach.who.kinds.hint',
    defaultMessage:
      'Turn a kind off and Plug never pitches it for this song. The count is how many fit your sound now; Plug finds more every day.',
  },
  fitNow: { id: 'app.outreach.who.kinds.fitNow', defaultMessage: '{count} fit now' },
  kindsAtLeastOne: { id: 'app.outreach.who.kinds.atLeastOne', defaultMessage: 'Keep at least one kind on.' },
  kindSpotifyPlaylist: { id: 'app.outreach.who.kind.spotifyPlaylist', defaultMessage: 'Spotify playlist curators' },
  kindSpotifyPlaylistSub: {
    id: 'app.outreach.who.kind.spotifyPlaylistSub',
    defaultMessage: 'Independent playlists that added artists like yours in the last 90 days.',
  },
  kindOtherPlaylist: { id: 'app.outreach.who.kind.otherPlaylist', defaultMessage: 'Apple Music and Deezer curators' },
  kindOtherPlaylistSub: {
    id: 'app.outreach.who.kind.otherPlaylistSub',
    defaultMessage: 'Curators with a public contact who add songs in your genres.',
  },
  kindPress: { id: 'app.outreach.who.kind.press', defaultMessage: 'Music blogs and magazines' },
  kindPressSub: {
    id: 'app.outreach.who.kind.pressSub',
    defaultMessage: 'Blogs that wrote about a similar artist this year and take submissions by email.',
  },
  kindNewsletter: { id: 'app.outreach.who.kind.newsletter', defaultMessage: 'Newsletters' },
  kindNewsletterSub: {
    id: 'app.outreach.who.kind.newsletterSub',
    defaultMessage: 'New-music newsletters for your genres.',
  },
  kindRadio: { id: 'app.outreach.who.kind.radio', defaultMessage: 'Online and college radio' },
  kindRadioSub: {
    id: 'app.outreach.who.kind.radioSub',
    defaultMessage: 'Shows that play new music. Best after the release day.',
  },
  kindPodcast: { id: 'app.outreach.who.kind.podcast', defaultMessage: 'Podcasts' },
  kindPodcastSub: { id: 'app.outreach.who.kind.podcastSub', defaultMessage: 'Music podcasts that play new songs.' },
  kindCreator: { id: 'app.outreach.who.kind.creator', defaultMessage: 'YouTube and TikTok creators' },
  kindCreatorSub: {
    id: 'app.outreach.who.kind.creatorSub',
    defaultMessage: 'Creators who feature songs like yours. Email only, never DMs.',
  },

  fineTuneTitle: { id: 'app.outreach.who.fineTune.title', defaultMessage: 'Fine-tune' },
  fineTuneHint: {
    id: 'app.outreach.who.fineTune.hint',
    defaultMessage: 'Plug starts from your sound profile. Change it only when you know better.',
  },
  yourSound: { id: 'app.outreach.who.fineTune.yourSound', defaultMessage: 'Your sound' },
  soundsLike: { id: 'app.outreach.who.fineTune.soundsLike', defaultMessage: 'Sounds like' },
  soundsLikeMore: {
    id: 'app.outreach.who.fineTune.soundsLikeMore',
    defaultMessage: '+ {count} from your sound profile',
  },
  countriesFirst: { id: 'app.outreach.who.fineTune.countries', defaultMessage: 'Countries first' },
  countriesThen: {
    id: 'app.outreach.who.fineTune.countriesThen',
    defaultMessage: 'Then anywhere with an English pitch',
  },
  playlistSize: { id: 'app.outreach.who.fineTune.size', defaultMessage: 'Playlist size' },
  playlistSizeValue: {
    id: 'app.outreach.who.fineTune.sizeValue',
    defaultMessage: '{min} to {max} followers',
  },
  playlistSizeFrom: {
    id: 'app.outreach.who.fineTune.sizeFrom',
    defaultMessage: '{min} followers and more',
  },
  playlistSizeNote: {
    id: 'app.outreach.who.fineTune.sizeNote',
    defaultMessage: 'Bigger ones rarely answer new artists',
  },
  notSetYet: { id: 'app.outreach.who.fineTune.notSet', defaultMessage: 'Not set yet' },

  neverTitle: { id: 'app.outreach.who.never.title', defaultMessage: 'Never contact' },
  neverHint: {
    id: 'app.outreach.who.never.hint',
    defaultMessage: 'Plug skips these for every campaign of this artist.',
  },
  neverCount: { id: 'app.outreach.who.never.count', defaultMessage: '{count} added' },
  neverPlaceholder: {
    id: 'app.outreach.who.never.placeholder',
    defaultMessage: 'Paste a playlist link, an email, a website or a name',
  },
  neverAdd: { id: 'app.outreach.who.never.add', defaultMessage: 'Add' },
  neverRemove: { id: 'app.outreach.who.never.remove', defaultMessage: 'Remove {label}' },
  neverNoMatch: {
    id: 'app.outreach.who.never.noMatch',
    defaultMessage: 'Plug did not pitch anyone with this name. Paste their email, website or playlist link.',
  },
  neverPick: { id: 'app.outreach.who.never.pick', defaultMessage: 'Plug pitched these. Pick one to block:' },
  neverUnknownPlaylist: {
    id: 'app.outreach.who.never.unknownPlaylist',
    defaultMessage: 'Plug does not know this playlist, so it never pitches it.',
  },
  neverFailed: { id: 'app.outreach.who.never.failed', defaultMessage: 'We could not add it. Try again.' },
  neverKindEmail: { id: 'app.outreach.who.never.kind.email', defaultMessage: 'Email' },
  neverKindDomain: { id: 'app.outreach.who.never.kind.domain', defaultMessage: 'Website' },
  neverKindPlaylist: { id: 'app.outreach.who.never.kind.playlist', defaultMessage: 'Playlist' },
  neverKindContact: { id: 'app.outreach.who.never.kind.contact', defaultMessage: 'Person' },
  alwaysSkipped: { id: 'app.outreach.who.never.always', defaultMessage: 'Always skipped' },
  skipMoney: { id: 'app.outreach.who.never.skipMoney', defaultMessage: 'People who ask for money' },
  skipBought: { id: 'app.outreach.who.never.skipBought', defaultMessage: 'Playlists that look bought' },
  skipStop: { id: 'app.outreach.who.never.skipStop', defaultMessage: 'Anyone who said stop' },
  skipEditorial: {
    id: 'app.outreach.who.never.skipEditorial',
    defaultMessage: 'Spotify editorial (use the pitch tool in Spotify for Artists)',
  },

  weekTitle: { id: 'app.outreach.who.week.title', defaultMessage: 'Your first week' },
  weekHint: {
    id: 'app.outreach.who.week.hint',
    defaultMessage: "Pitches go out on weekdays, in each person's morning. A new mailbox sends a few first, then more.",
  },
  weekOut: { id: 'app.outreach.who.week.out', defaultMessage: '{day} · OUT' },
  weekNone: { id: 'app.outreach.who.week.none', defaultMessage: 'No pitches' },
  weekCount: { id: 'app.outreach.who.week.count', defaultMessage: '{count}' },
  weekWarmup: { id: 'app.outreach.who.week.warmup', defaultMessage: '{count} · warm-up' },
  weekFollowUps: {
    id: 'app.outreach.who.week.followUps',
    defaultMessage: '{count} + {followUps, plural, one {# follow-up} other {# follow-ups}}',
  },
  legendNew: { id: 'app.outreach.who.week.legendNew', defaultMessage: 'New pitch' },
  legendFollowUp: { id: 'app.outreach.who.week.legendFollowUp', defaultMessage: 'Follow-up (free)' },

  barSummary: {
    id: 'app.outreach.who.bar',
    defaultMessage: '{kinds, plural, one {# kind} other {# kinds}} on · {fit} fit now · {rate} a day',
  },
  saveFailed: { id: 'app.outreach.who.saveFailed', defaultMessage: 'We could not save the change. Try again.' },
});
